import jsPDF from "jspdf";
import "jspdf-autotable";

const invoiceGeneratePdf = (
  data,
  invNo,
  invdate,
  provider,
  facilityname,
  providerStreet,
  providerCity,
  providerState,
  providerNum,
  providerMail,
  patName,
  patNumber,
  patStreet,
  patCity,
  patState,
  patZip,
  patEmail,
  amount,
  balance,
  ext,
  Base,
  statelogo,
  symbol
) => {
  const doc = new jsPDF();

  let i = 0;

  var rows = [];

  const cols = ["Date ", "Description", "Amount"];

  for (i = 0; i < data.length; i++) {
    rows.push([
      data[i]["date"],
      data[i]["serviceName"],
      `${symbol}${data[i]["fee"]}`,
    ]);
  }

  doc.setFontSize(13);
  doc.setFillColor(247, 247, 247);
  doc.rect(0, 0, 220, 35, "F");
  if (statelogo !== "0" && Base) {
    try {
      doc.addImage(Base, ext, 8, 8, 24, 21);
    } catch (error) {
      console.warn("Failed to add image to PDF:", error);
    }
  }
  if (balance === "0.00") {
    doc.setFontSize(15);
    doc.setDrawColor(0, 128, 0);
    doc.roundedRect(60, 8, 30, 18, 2, 2, "FD");
    doc.setTextColor(0, 128, 0);
    doc.text(70, 19, "PAID");
  }
  doc.setDrawColor(0, 0, 0);
  doc.setTextColor(0, 0, 0);
  doc.text(130, 10, "Invoice");
  doc.text(130, 20, "Invoice id");
  doc.text(130, 30, "issue date");
  doc.setLineWidth(0.5);
  doc.line(155, 17, 155, 30);
  doc.text(160, 20, `${invNo}`);
  doc.text(160, 30, `${invdate}`);
  const lineHeight = 6;
  const startY = 50;
  const billFromX = 8;
  const billToX = 130;

  // ---------- BILL FROM ----------
  doc.setFontSize(13);
  doc.setTextColor(0, 0, 0);
  doc.text(billFromX, startY, "Bill From");

  doc.setFontSize(12);
  doc.setTextColor(113, 128, 150);
  let yFrom = startY + lineHeight;

  const facilityLines = doc.splitTextToSize(facilityname || "", 90);
  doc.text(billFromX, yFrom, facilityLines);
  yFrom += facilityLines.length * lineHeight;

  const addressLine1 = doc.splitTextToSize(providerStreet || "", 90);
  doc.text(billFromX, yFrom, addressLine1);
  yFrom += addressLine1.length * lineHeight;

  const addressLine2 = doc.splitTextToSize(`${providerCity || ""}`, 90);
  doc.text(billFromX, yFrom, addressLine2);
  yFrom += addressLine2.length * lineHeight;

  const addressLine3 = doc.splitTextToSize(`${providerState || ""}`, 90);
  doc.text(billFromX, yFrom, addressLine3);
  yFrom += addressLine3.length * lineHeight;

  // ---------- BILL TO ----------
  doc.setFontSize(13);
  doc.setTextColor(0, 0, 0);
  doc.text(billToX, startY, "Bill To");

  doc.setFontSize(12);
  doc.setTextColor(113, 128, 150);
  let yTo = startY + lineHeight;

  const patNames = doc.splitTextToSize(patName || "", 70);
  doc.text(billToX, yTo, patNames || "");
  yTo += patNames.length * lineHeight;

  const patStreetLines = doc.splitTextToSize(patStreet || "", 70);
  doc.text(billToX, yTo, patStreetLines);
  yTo += patStreetLines.length * lineHeight;

  const patAddrLines = doc.splitTextToSize(
    `${patCity}, ${patState} ${patZip}`,
    70
  );
  doc.text(billToX, yTo, patAddrLines);
  yTo += patAddrLines.length * lineHeight;

  // ---------- ALIGN PROVIDER & CLIENT BASED ON MAX Y ----------
  const nextY = Math.max(yFrom, yTo) + 10;

  // ---------- PROVIDER ----------
  let yProvider = nextY;
  doc.setFontSize(13);
  doc.setTextColor(0, 0, 0);
  doc.text(billFromX, yProvider, "Provider");
  yProvider += lineHeight;

  doc.setFontSize(12);
  doc.setTextColor(113, 128, 150);
  const providername = doc.splitTextToSize(provider || "", 90);
  doc.text(billFromX, yProvider, providername || "");
  yProvider += lineHeight * providername.length;

  doc.text(billFromX, yProvider, "Tax ID :");
  doc.text(billFromX + 17, yProvider, providerNum || "");
  yProvider += lineHeight;

  doc.text(billFromX, yProvider, providerMail || "");
  yProvider += lineHeight;

  // ---------- CLIENT ----------
  let yClient = nextY;
  doc.setFontSize(13);
  doc.setTextColor(0, 0, 0);
  doc.text(billToX, yClient, "Client");
  yClient += lineHeight;

  doc.setFontSize(12);
  doc.setTextColor(113, 128, 150);
  const patientname = doc.splitTextToSize(patName || "", 70);
  doc.text(billToX, yClient, patientname || "");
  yClient += lineHeight * patientname.length;

  doc.text(billToX, yClient, patNumber || "");
  yClient += lineHeight;

  doc.text(billToX, yClient, patEmail || "");
  yClient += lineHeight;

  // ---------- TABLE ----------
  doc.setDrawColor(247, 247, 247);
  doc.autoTable({
    head: [cols],
    body: rows,
    startY: Math.max(yProvider, yClient) + 10,
    theme: "plain",
    margin: { left: 0, right: 0 },
    styles: {
      cellPadding: { top: 4, right: 5, bottom: 4, left: 8 },
      fontSize: 10,
    },

    headStyles: {
      fillColor: [247, 247, 247],
      textColor: [0, 0, 0],
      fontStyle: "normal",
      halign: "left",
      fontSize: 12,
    },
    bodyStyles: {
      fillColor: (255, 255, 255),
      fontStyle: "normal",
      halign: "left",
      fontSize: 12,
    },
    willDrawCell: (data) => {
      if (data.row.index != 0) {
        doc.setDrawColor(216, 224, 240);
        doc.setLineWidth(1);
        doc.line(
          data.cell.x + data.column.width,
          data.cell.y,
          data.cell.x,
          data.cell.y
        );
      }
    },
  });
  let final = doc.previousAutoTable.finalY;
  doc.setDrawColor(216, 224, 240);
  doc.setLineWidth(0.035);
  doc.line(0, final, 220, final);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(13);
  doc.setTextColor(0, 0, 0);
  doc.text(138, final + 20, "Total:");
  doc.text(150, final + 20, `${symbol}${amount}`);
  doc.text(110, final + 30, "Make Payments to:");
  const facilityName = doc.splitTextToSize(`${facilityname}`, 60);
  doc.text(150, final + 30, facilityName);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  doc.setTextColor(113, 128, 150);
  doc.text("Powered by Vozo", doc.internal.pageSize.width / 2, 290, {
    align: "center",
  });

  doc.save(`invoice of ${patName}_${invNo}.pdf`);
};

export default invoiceGeneratePdf;
